export default __webpack_public_path__ + "static/media/plus.dbd04e5d.svg";